import { RootState } from "../store";

export const getIsLoadingSpinnerVisible = (state: RootState): boolean =>
    state.loadingSpinnerReducer.count > 0;
